import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, ChangeDetectionStrategy, Host, Input, NgModule } from '@angular/core';
import * as i2 from '@ng-dot/ux/color';
import { DotColorDirective } from '@ng-dot/ux/color';
import * as i1 from '@ng-dot/ux/shape';
import { DotShapeDirective } from '@ng-dot/ux/shape';
class DotLoaderComponent {
  inline;
  constructor(_$shape) {
    _$shape.shapePrefix = '_';
    _$shape.shape = 'circle';
  }
  static ɵfac = function DotLoaderComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLoaderComponent)(i0.ɵɵdirectiveInject(i1.DotShapeDirective, 1));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: DotLoaderComponent,
    selectors: [["dot-loader"]],
    hostAttrs: [1, "dot-loader"],
    hostVars: 2,
    hostBindings: function DotLoaderComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵclassProp("_inline", ctx.inline);
      }
    },
    inputs: {
      inline: "inline"
    },
    standalone: false,
    features: [i0.ɵɵHostDirectivesFeature([{
      directive: i1.DotShapeDirective,
      inputs: ["shape", "shape"]
    }, {
      directive: i2.DotColorDirective,
      inputs: ["color", "color"]
    }])],
    decls: 11,
    vars: 0,
    template: function DotLoaderComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "span");
        i0.ɵɵelement(1, "b")(2, "b")(3, "b")(4, "b")(5, "b")(6, "b")(7, "b")(8, "b")(9, "b")(10, "b");
        i0.ɵɵelementEnd();
      }
    },
    styles: [".dot-loader{display:inline-block;animation:LHBAItQ8xosTXzt0dWDBWIp5TK7TB5de .48s both}@keyframes LHBAItQ8xosTXzt0dWDBWIp5TK7TB5de{0%{opacity:0}}.dot-loader span{display:block;position:relative;width:1.5em;height:1.5em}.dot-loader b{position:absolute;top:0;left:0;display:none}.dot-loader._circle span{animation:E85y1t11nmqzij8YhCLqq7iBJfsDATwo 1.44s linear infinite}@keyframes E85y1t11nmqzij8YhCLqq7iBJfsDATwo{to{transform:rotate(360deg)}}.dot-loader._circle b{width:1.25em;height:1.25em;border:solid rgb(127.5,127.5,127.5) .125em;border-radius:50%;border-right-color:transparent!important;animation:joQ74NAT1sjswei7Z3x6PiHVPKPqG9iU .96s infinite}@keyframes joQ74NAT1sjswei7Z3x6PiHVPKPqG9iU{to{transform:rotate(360deg)}}.dot-loader._circle b:nth-child(1){display:block}.dot-loader._flip b{background-color:gray;width:100%;height:100%;perspective:512px;animation:BHBEupU9HxwCuZJvr3pzfSRLagBdpJyI .96s linear infinite}@keyframes BHBEupU9HxwCuZJvr3pzfSRLagBdpJyI{50%{transform:rotateX(180deg)}to{transform:rotateX(180deg) rotateY(180deg)}}.dot-loader._flip b:nth-child(1){display:block}.dot-loader._flip9 b{background-color:gray;width:33.33%;height:33.33%;perspective:512px;display:block;animation:pfIqpdjHDDSEJuvH5sTRssANlMstxtV6 2.4s both infinite}@keyframes pfIqpdjHDDSEJuvH5sTRssANlMstxtV6{0%{transform:scale(1)}to{transform:scale(1) rotateX(-180deg) rotateY(180deg)}}.dot-loader._flip9 b:nth-child(2),.dot-loader._flip9 b:nth-child(5),.dot-loader._flip9 b:nth-child(8){left:33.33%}.dot-loader._flip9 b:nth-child(3),.dot-loader._flip9 b:nth-child(6),.dot-loader._flip9 b:nth-child(9){left:66.66%}.dot-loader._flip9 b:nth-child(4),.dot-loader._flip9 b:nth-child(5),.dot-loader._flip9 b:nth-child(6){top:33.33%}.dot-loader._flip9 b:nth-child(7),.dot-loader._flip9 b:nth-child(8),.dot-loader._flip9 b:nth-child(9){top:66.66%}.dot-loader._flip9 b:nth-child(6),.dot-loader._flip9 b:nth-child(8){animation-delay:.48s}.dot-loader._flip9 b:nth-child(3),.dot-loader._flip9 b:nth-child(5),.dot-loader._flip9 b:nth-child(7){animation-delay:.96s}.dot-loader._flip9 b:nth-child(2),.dot-loader._flip9 b:nth-child(4){animation-delay:1.44s}.dot-loader._flip9 b:nth-child(1){animation-delay:1.92s}.dot-loader._bar b{background-color:gray;width:15.626%;height:100%;animation:hL7UBLTbwz8AHm8OuSr9IlX1xqFEu9Eh .96s infinite}@keyframes hL7UBLTbwz8AHm8OuSr9IlX1xqFEu9Eh{50%{transform:scaleY(.46)}}.dot-loader._bar b:nth-child(1),.dot-loader._bar b:nth-child(2),.dot-loader._bar b:nth-child(3),.dot-loader._bar b:nth-child(4){display:block}.dot-loader._bar b:nth-child(2){left:28.126%;animation-delay:.12s}.dot-loader._bar b:nth-child(3){left:56.252%;animation-delay:.24s}.dot-loader._bar b:nth-child(4){left:84.378%;animation-delay:.36s}\n", "html dot-loader{display:block;margin:0 auto}*:has(>dot-loader:first-child:last-child) dot-loader{display:flex;align-items:center}*:has(>dot-loader:first-child:last-child) dot-loader>span{margin:0 auto}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLoaderComponent, [{
    type: Component,
    args: [{
      selector: 'dot-loader',
      template: `
		<span>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
			<b></b>
		</span>
	`,
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        'class': 'dot-loader',
        '[class._inline]': 'inline'
      },
      hostDirectives: [{
        directive: DotShapeDirective,
        inputs: ['shape']
      }, {
        directive: DotColorDirective,
        inputs: ['color']
      }],
      standalone: false,
      styles: [".dot-loader{display:inline-block;animation:LHBAItQ8xosTXzt0dWDBWIp5TK7TB5de .48s both}@keyframes LHBAItQ8xosTXzt0dWDBWIp5TK7TB5de{0%{opacity:0}}.dot-loader span{display:block;position:relative;width:1.5em;height:1.5em}.dot-loader b{position:absolute;top:0;left:0;display:none}.dot-loader._circle span{animation:E85y1t11nmqzij8YhCLqq7iBJfsDATwo 1.44s linear infinite}@keyframes E85y1t11nmqzij8YhCLqq7iBJfsDATwo{to{transform:rotate(360deg)}}.dot-loader._circle b{width:1.25em;height:1.25em;border:solid rgb(127.5,127.5,127.5) .125em;border-radius:50%;border-right-color:transparent!important;animation:joQ74NAT1sjswei7Z3x6PiHVPKPqG9iU .96s infinite}@keyframes joQ74NAT1sjswei7Z3x6PiHVPKPqG9iU{to{transform:rotate(360deg)}}.dot-loader._circle b:nth-child(1){display:block}.dot-loader._flip b{background-color:gray;width:100%;height:100%;perspective:512px;animation:BHBEupU9HxwCuZJvr3pzfSRLagBdpJyI .96s linear infinite}@keyframes BHBEupU9HxwCuZJvr3pzfSRLagBdpJyI{50%{transform:rotateX(180deg)}to{transform:rotateX(180deg) rotateY(180deg)}}.dot-loader._flip b:nth-child(1){display:block}.dot-loader._flip9 b{background-color:gray;width:33.33%;height:33.33%;perspective:512px;display:block;animation:pfIqpdjHDDSEJuvH5sTRssANlMstxtV6 2.4s both infinite}@keyframes pfIqpdjHDDSEJuvH5sTRssANlMstxtV6{0%{transform:scale(1)}to{transform:scale(1) rotateX(-180deg) rotateY(180deg)}}.dot-loader._flip9 b:nth-child(2),.dot-loader._flip9 b:nth-child(5),.dot-loader._flip9 b:nth-child(8){left:33.33%}.dot-loader._flip9 b:nth-child(3),.dot-loader._flip9 b:nth-child(6),.dot-loader._flip9 b:nth-child(9){left:66.66%}.dot-loader._flip9 b:nth-child(4),.dot-loader._flip9 b:nth-child(5),.dot-loader._flip9 b:nth-child(6){top:33.33%}.dot-loader._flip9 b:nth-child(7),.dot-loader._flip9 b:nth-child(8),.dot-loader._flip9 b:nth-child(9){top:66.66%}.dot-loader._flip9 b:nth-child(6),.dot-loader._flip9 b:nth-child(8){animation-delay:.48s}.dot-loader._flip9 b:nth-child(3),.dot-loader._flip9 b:nth-child(5),.dot-loader._flip9 b:nth-child(7){animation-delay:.96s}.dot-loader._flip9 b:nth-child(2),.dot-loader._flip9 b:nth-child(4){animation-delay:1.44s}.dot-loader._flip9 b:nth-child(1){animation-delay:1.92s}.dot-loader._bar b{background-color:gray;width:15.626%;height:100%;animation:hL7UBLTbwz8AHm8OuSr9IlX1xqFEu9Eh .96s infinite}@keyframes hL7UBLTbwz8AHm8OuSr9IlX1xqFEu9Eh{50%{transform:scaleY(.46)}}.dot-loader._bar b:nth-child(1),.dot-loader._bar b:nth-child(2),.dot-loader._bar b:nth-child(3),.dot-loader._bar b:nth-child(4){display:block}.dot-loader._bar b:nth-child(2){left:28.126%;animation-delay:.12s}.dot-loader._bar b:nth-child(3){left:56.252%;animation-delay:.24s}.dot-loader._bar b:nth-child(4){left:84.378%;animation-delay:.36s}\n", "html dot-loader{display:block;margin:0 auto}*:has(>dot-loader:first-child:last-child) dot-loader{display:flex;align-items:center}*:has(>dot-loader:first-child:last-child) dot-loader>span{margin:0 auto}\n"]
    }]
  }], () => [{
    type: i1.DotShapeDirective,
    decorators: [{
      type: Host
    }]
  }], {
    inline: [{
      type: Input
    }]
  });
})();
class DotLoaderModule {
  static ɵfac = function DotLoaderModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || DotLoaderModule)();
  };
  static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: DotLoaderModule
  });
  static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DotLoaderModule, [{
    type: NgModule,
    args: [{
      declarations: [DotLoaderComponent],
      imports: [CommonModule],
      exports: [DotLoaderComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DotLoaderComponent, DotLoaderModule };
